import 'quill/dist/quill.snow.css';
import { useQuill } from 'react-quilljs';
import { useEffect } from 'react';
import Delta from 'quill-delta';

export interface RichTextRendererProps {
  content: Delta;
}

export function RichTextRenderer({ content }: RichTextRendererProps) {
  const { quill, quillRef } = useQuill({
    readOnly: true,
  });

  useEffect(() => {
    if (quill && content) {
      quill.setContents(content);
    }
  }, [content, quill]);

  return (
    <div>
      <style>
        {`
          .ql-container.ql-snow {
            border: none;
          }
          .ql-toolbar.ql-snow {
            display: none;
          }
          .ql-container.ql-snow > input {
            display: none;
          }
          .ql-container{
            font-size: inherit;
            margin: auto;
          }
        `}
      </style>
      <div
        ref={quillRef}
        className="text-lg md:text-xl leading-relaxed max-w-2xl mx-auto"
      ></div>
    </div>
  );
}

export default RichTextRenderer;
